module.exports = __webpack_public_path__ + "img/禾丽医美.2ca83c7.png";